import { CREATED, getStatusText } from 'http-status-codes';
import { takeLatest, call, put } from 'redux-saga/effects';

import { actions as couponsActions } from '../details/duck';

import { types, actions } from './duck';
import { reserveCoupon } from '../../coupons/api';

export function* reserveCouponSaga({ couponId, payByPoints, resolve, reject }) {
  try {
    const response = yield call(reserveCoupon, couponId, !!payByPoints);

    // Update coupon detail state on any response.
    // It will handle cases of 'coupon expiry' or 'coupon was deleting'.
    yield put(couponsActions.getDetail(couponId));

    if (response.status === CREATED) {
      yield put(actions.reserveCouponSuccess(couponId, response.data));
      resolve(response.data);
    } else if (Array.isArray(response.data)) {
      throw new Error(response.data.join('. '));
    } else if (Array.isArray(response.data.coupon)) {
      throw new Error(response.data.coupon[0]);
    } else {
      throw new Error(getStatusText(response.status));
    }
  } catch (error) {
    yield put(actions.reserveCouponFailure(couponId, error.message));
    reject(error.message);
  }
}

export default function* saga() {
  yield takeLatest(types.RESERVE_COUPON, reserveCouponSaga);
}
